<template>
  <div class="store-locator-section">
    <div class="header">
      <div class="header__title">
        <div class="header__wrapper">
          <div class="header__icon">
            <slot name="icon"></slot>
          </div>
          <span :class="{ light: !name }">{{ sectionName }}</span>
        </div>
      </div>
      <div class="header__actions">
        <div>
          <span>{{ $t("message.storeLocator.extraInfo.moveSection") }}</span>
          <ui-button
            outlined
            icon="icon-arrow-down"
            small
            shadow
            @click="$emit('move-down')"
          ></ui-button>

          <ui-button
            outlined
            icon="icon-arrow-up"
            small
            shadow
            @click="$emit('move-up')"
          ></ui-button>
        </div>
        <ui-button outlined icon="icon-edit" shadow @click="$emit('edit')">
          {{ $t("message.common.edit") }}
        </ui-button>
        <ui-button
          outlined
          icon="icon-trash"
          icon-color="pink"
          shadow
          :loading="isDeleting"
          @click="$emit('delete-section')"
        >
          {{ $t("message.common.delete") }}
        </ui-button>
      </div>
    </div>
    <div class="elements-table">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "BaseSection",
  props: {
    id: Number,
    name: String,
    defaultName: String,
    isDeleting: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    sectionName() {
      return this.name || this.defaultName;
    }
  }
};
</script>

<style lang="scss" scoped>
.store-locator-section {
  width: 100%;
  border: 1px solid $primary-light;
  border-radius: 8px;
  margin: 0;
  padding-bottom: $spacing;
}

.header {
  margin: $spacing * 2;
  margin-bottom: 0;
  display: flex;
  flex-direction: row;
  align-items: top;
  justify-content: space-between;

  &__title {
    display: flex;
    align-items: top;
    font-size: 16px;
    font-weight: 500;
    gap: $spacing * 2;
  }

  &__actions {
    display: flex;
    align-items: center;

    & button {
      margin-left: $spacing * 2;
      margin-bottom: $spacing;
    }
  }

  &__wrapper {
    display: flex;
    height: max-content;
    align-items: center;
    gap: $spacing * 1.5;
  }

  &__icon {
    width: 31px;
    height: 31px;
    background-color: $primary;
    border-radius: 7px;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.light {
  color: $gray-600;
}

.elements-table {
  padding: 0 $spacing * 2;

  ::v-deep .theme--light.v-data-table {
    thead tr th {
      font-weight: 500;
      color: $primary !important;
      font-size: 15px;
    }

    tbody tr td,
    thead tr th {
      padding: 0 !important;
    }

    tbody tr:hover {
      background: transparent !important;
    }
  }
}
</style>
